import { ErrorObject } from '@qpr/client-library/dist/esm/ErrorContext';
import { Diagram } from './components/DiagramContent';
import { Document } from './components/DocumentsContent';
import { Measure } from './components/MetricsContent';

export interface PropertiesState {
  data: Data;
  error?: ErrorObject;
}

export interface Data {
  properties?: Record<string, string>;
  documents?: Document[];
  measures?: Measure;
  diagram?: Diagram;
}

const initialState = {
  data: {
    properties: {
      name: '',
      description: ''
    },
    documents: [],
    measures: {} as Measure
  }
} as PropertiesState;

export default initialState;
